import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { ElevioCard } from '../../integrations/elevio/src/components/ElevioCard';
import { KnowledgeErrorPlaceholder } from '../../integrations/elevio/src/components/KnowledgeErrorPlaceholder';
import { KnowledgeSuggestions } from '../../integrations/knowledge/components/knowledgeSuggestions';
import { CardSection } from '../components/cardSection/cardSection';
import type { SidebarMode } from '../conversationSidebar.types';
import { useCardVisibility } from '../hooks/useCardVisibility';

import knowledgeCardStyles from './KnowledgeCard.module.scss';

type KnowledgeCardProps = {
  isMinimized: boolean;
  sidebarMode: SidebarMode;
  index: number;
};

export function SuggestionCards({
  isMinimized,
  sidebarMode,
  index,
}: KnowledgeCardProps): JSX.Element {
  const { hiddenCards } = useCardVisibility();

  const { elevioSuggestions, knowledgeSuggestions } = useFeatureFlag([
    'elevio-suggestions',
    'knowledge-suggestions',
  ]);

  const hasKnowledgeReadAccess = useHasAccess('knowledge.content:r');

  const isKnowledgeOnForUser = knowledgeSuggestions && hasKnowledgeReadAccess;

  return (
    <ErrorBoundary fallback={<KnowledgeErrorPlaceholder />}>
      {elevioSuggestions || isKnowledgeOnForUser ? (
        <CardSection
          title={!isMinimized ? 'Knowledge' : undefined}
          index={index}
          isMinimized={isMinimized}
        >
          {isKnowledgeOnForUser &&
            (sidebarMode === 'visibility' ||
              !hiddenCards.has('knowledge-suggestions')) && (
              <div
                data-testid="knowledgeCard"
                className={knowledgeCardStyles.knowledgeCard}
              >
                <KnowledgeSuggestions isMinimized={isMinimized} />
              </div>
            )}
          {elevioSuggestions &&
            (sidebarMode === 'visibility' || !hiddenCards.has('elevio')) && (
              <div className={knowledgeCardStyles.elevioCard}>
                <ElevioCard isMinimized={isMinimized} />
              </div>
            )}
        </CardSection>
      ) : (
        <></>
      )}
    </ErrorBoundary>
  );
}
